import { useMutation } from '@tanstack/react-query';

import { DispatchEventClient, DispatchEventReport } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const dispatchEventClient = new DispatchEventClient(apiBaseUrl);

function useSaveNewDispatchEvent() {
  return useMutation({
    mutationKey: [queryKeys.DispatchEvent.SaveNew],
    mutationFn: (report: DispatchEventReport) => dispatchEventClient.saveNew(report),
  });
}

export default useSaveNewDispatchEvent;
